module.exports = __webpack_public_path__ + "static/media/ql-icon-menu.fbb11fe6.svg";